/* AgriEID: a smaller, easier to reach button for the store's chat (v270, 8 Oct 2026).

   The chat itself belongs to the Shoply chat app ("Chat with our Team!"); this file changes only how it looks
   while it is closed. When that app is on the page it:
   1. swaps the app's wide pill for one round button in the same corner. "Chat with our team" slides out when
      the pointer or the keyboard reaches it and, on tablets and computers, for a few seconds on a visitor's
      first page;
   2. adds "Chat with our team" at the top of every page: at the right end of the announcement bar where the
      full menu shows, as a button beside the cart where the compact header shows (phones, tablets);
   3. keeps the Esc key from opening the chat (the app opens on any Esc press). Esc still closes it.
   Where the app is not on the page (the demo store, or the app switched off) nothing is added. If the app's
   own button cannot be found, its pill is left exactly as it is.

   Own file with its styles inside, like ae-zoom.js and ae-video-pop.js. Loaded by one line in
   layout/theme.liquid. To change the words, edit LABEL below. To switch all of this off, remove that line. */
(function () {
  'use strict';
  if (window.AEChat) return;

  var LABEL = 'Chat with our team';   // the words on the round button and the top link
  var HELLO_MS = 6000;                // how long the words stay out on a visitor's first page (tablets, computers)
  var HOST = '#floating-shopping-assistant';   // the element the chat app renders into (its own shadow root)
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.5 11.6a8 8 0 0 1-11.9 7L4 20l1.4-4.3A8 8 0 1 1 20.5 11.6z"/><path d="M8.5 11.6h.01M12.5 11.6h.01M16.5 11.6h.01"/></svg>';
  var CSS = [
    /* the round button */
    '.ae-chat{position:fixed;right:24px;bottom:calc(24px + env(safe-area-inset-bottom,0px));z-index:99;display:flex;flex-direction:row-reverse;align-items:center;height:60px;min-width:60px;margin:0;padding:0;border:0;border-radius:30px;background:#000080;color:#fff;font:600 15px/1 "DM Sans",system-ui,-apple-system,"Segoe UI",sans-serif;letter-spacing:0;text-transform:none;cursor:pointer;box-shadow:0 0 0 2px #fff,0 10px 26px rgba(0,0,60,.38);-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none}',
    '.ae-chat__face{position:relative;flex:none;width:52px;height:52px;margin:4px;border-radius:50%;background:#fff;color:#000080;display:grid;place-items:center;overflow:hidden}',
    '.ae-chat__face img{width:100%;height:100%;object-fit:cover;display:block}',
    '.ae-chat__face svg{width:26px;height:26px}',
    '.ae-chat__badge{position:absolute;right:-2px;bottom:-2px;width:24px;height:24px;border-radius:50%;background:#fff;color:#000080;display:grid;place-items:center;box-shadow:0 1px 4px rgba(0,0,60,.35)}',
    '.ae-chat__badge svg{width:15px;height:15px}',
    '.ae-chat__label{max-width:0;overflow:hidden;white-space:nowrap;padding:0;transition:max-width .35s ease,padding .35s ease}',
    '.ae-chat:focus-visible .ae-chat__label,.ae-chat.is-hello .ae-chat__label{max-width:240px;padding:0 6px 0 22px}',
    '@media (hover:hover){.ae-chat:hover .ae-chat__label{max-width:240px;padding:0 6px 0 22px}}',
    '.ae-chat:focus-visible,.ae-chat-top:focus-visible{outline:3px solid #FFBF47;outline-offset:3px}',
    '.ae-chat.is-open{visibility:hidden}',
    '@media (max-width:749px){.ae-chat{right:12px;bottom:calc(10px + env(safe-area-inset-bottom,0px));height:52px;min-width:52px;border-radius:26px}.ae-chat__face{width:44px;height:44px}.ae-chat__badge{width:22px;height:22px}}',
    '@media (prefers-reduced-motion:reduce){.ae-chat__label{transition:none}}',
    '@media print{.ae-chat,.ae-chat-top{display:none!important}}',
    /* the link at the top of the page */
    '.ae-chat-top{display:inline-flex;align-items:center;justify-content:center;gap:8px;margin:0;font:600 14px/1 "DM Sans",system-ui,-apple-system,"Segoe UI",sans-serif;letter-spacing:0;text-transform:none;white-space:nowrap;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none}',
    '.ae-chat-top svg{width:16px;height:16px;flex:none}',
    '.ae-chat-top--bar{position:absolute;right:var(--ae-chat-r,32px);top:50%;transform:translateY(-50%);z-index:2;height:30px;padding:0 14px 0 12px;border-radius:15px;border:1.5px solid rgba(255,255,255,.75);background:rgba(255,255,255,.1);color:#fff;transition:background-color .2s ease,color .2s ease}',
    '.ae-chat-top--bar:hover{background:#fff;color:#000080}',
    '.ae-chat-top--head{flex:none;height:32px;min-width:44px;padding:0 10px;margin-right:8px;border-radius:8px;border:1.5px solid #000080;background:#fff;color:#000080}',
    '.ae-chat-top--head svg{width:18px;height:18px}',
    '.ae-chat-top--head span{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}'
  ].join('\n');

  var btn = null, top = null, opener = null, wasOpen = false, lastW = 0, tries = 0;

  function parts() {
    var host = document.querySelector(HOST), root = host && host.shadowRoot;
    if (!root) return null;
    var app = root.querySelector('.ChatIconHolder button'), drawer = root.querySelector('.ant-drawer');
    return app && drawer ? { host: host, root: root, app: app, drawer: drawer } : null;
  }
  function isOpen() { var p = parts(); return !!(p && p.drawer.classList.contains('ant-drawer-open')); }

  function open(from) {
    var p = parts(); if (!p) return;
    opener = from || null;
    if (!p.drawer.classList.contains('ant-drawer-open')) p.app.click();
  }

  function make(tag, cls, html) { var e = document.createElement(tag); e.className = cls; e.innerHTML = html; if (tag === 'button') e.type = 'button'; e.setAttribute('aria-haspopup', 'dialog'); e.setAttribute('aria-expanded', 'false'); return e; }

  // Where the top link goes: the announcement bar where the full menu shows and there is room beside the
  // bar's own words; otherwise a button beside the cart.
  function placeTop() {
    if (top) { top.remove(); top = null; }
    if (!parts()) return;
    var utils = document.querySelector('.mega-nav__utils');
    var login = utils && utils.querySelector('.mega-nav__login-btn');
    var full = !!(login && login.getClientRects().length);
    var bar = document.querySelector('.ae-announce');
    if (full && bar && !bar.classList.contains('is-marquee') && bar.parentElement) {
      var wrap = bar.parentElement, b = bar.getBoundingClientRect();
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      var r = Math.max(16, Math.round(window.innerWidth - utils.getBoundingClientRect().right));
      var el = make('button', 'ae-chat-top ae-chat-top--bar', ICON + '<span>' + LABEL + '</span>');
      el.style.setProperty('--ae-chat-r', r + 'px');
      wrap.insertBefore(el, bar.nextSibling);
      // room: the bar's words are centred; the link must end clear of them
      var text = bar.querySelector('.ae-announce__text'), need = 0;
      if (text) { var probe = text.cloneNode(true); probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;padding:0;animation:none;min-width:0;width:auto;max-width:none'; bar.appendChild(probe); need = probe.getBoundingClientRect().width; bar.removeChild(probe); }
      var textRight = b.left + (b.width + need) / 2;
      if (el.getBoundingClientRect().left - textRight >= 20) { top = el; }
      else el.remove();
    }
    if (!top && utils) {
      var cart = utils.querySelector('.mega-nav__cart-btn-styled');
      var hb = make('button', 'ae-chat-top ae-chat-top--head', ICON + '<span>' + LABEL + '</span>');
      hb.setAttribute('aria-label', LABEL);
      utils.insertBefore(hb, full ? (utils.querySelector('.mega-nav__search-btn') || login) : (cart || null));
      // never push the header's own buttons off the screen
      var last = utils.lastElementChild, over = last && last.getBoundingClientRect().right > document.documentElement.clientWidth - 4;
      if (over) hb.remove(); else top = hb;
    }
    if (top) { top.addEventListener('click', function (e) { e.preventDefault(); open(top); }); top.setAttribute('aria-expanded', isOpen() ? 'true' : 'false'); }
  }

  function putAway(root) {   // the app's own pill; put back if the app ever clears our style
    if (root.querySelector('style[data-ae-chat]')) return;
    var hide = document.createElement('style'); hide.setAttribute('data-ae-chat', ''); hide.textContent = '.ChatIconHolder{display:none!important}'; root.appendChild(hide);
  }

  function sync() {
    var o = isOpen(), p = parts();
    if (p && btn) putAway(p.root);
    if (btn) { btn.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    if (top) top.setAttribute('aria-expanded', o ? 'true' : 'false');
    // closed again: hand the keyboard back to whichever control opened it
    if (wasOpen && !o && opener && document.contains(opener)) {
      var a = document.activeElement;
      if (!a || a === document.body || a.matches(HOST)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
      opener = null;
    }
    wasOpen = o;
  }

  function build() {
    var p = parts(); if (!p || btn) return !!btn;
    var st = document.createElement('style'); st.id = 'ae-chat-css'; st.textContent = CSS; document.head.appendChild(st);
    var img = p.app.querySelector('img'), src = img && img.getAttribute('src');
    btn = make('button', 'ae-chat', '<span class="ae-chat__face">' + (src ? '<img src="' + src.replace(/"/g, '&quot;') + '" alt="" width="52" height="52" decoding="async">' : ICON) + '</span>' + (src ? '<span class="ae-chat__badge">' + ICON + '</span>' : '') + '<span class="ae-chat__label">' + LABEL + '</span>');
    btn.setAttribute('aria-label', LABEL);
    var face = btn.querySelector('img');
    if (face) face.addEventListener('error', function () { btn.querySelector('.ae-chat__face').innerHTML = ICON; var bd = btn.querySelector('.ae-chat__badge'); if (bd) bd.remove(); });
    btn.addEventListener('click', function () { open(btn); });
    document.body.appendChild(btn);
    // only now is the app's own pill put away
    putAway(p.root);
    placeTop();
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; sync(); }); }).observe(p.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    sync();
    lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; clearTimeout(placeTop.t); placeTop.t = setTimeout(placeTop, 150); });
    // the announcement bar decides between its two looks a moment after loading
    setTimeout(placeTop, 1200);
    // first page of a visit, tablets and computers: the words show once, then tuck away
    try {
      if (window.innerWidth >= 750 && !sessionStorage.getItem('aeChatHello')) {
        sessionStorage.setItem('aeChatHello', '1');
        setTimeout(function () { btn.classList.add('is-hello'); setTimeout(function () { btn.classList.remove('is-hello'); }, HELLO_MS); }, 1500);
      }
    } catch (e) {}
    return true;
  }

  // Esc: the app opens on any Esc press. While the chat is closed the key stops here, after every other part of
  // the page has had it (menus, the photo viewer and the video player close on Esc as before); while it is open
  // the key goes through and closes it.
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && document.querySelector(HOST) && !isOpen()) e.stopPropagation();
  });

  // The app arrives some time after the page: look for it for the first 30 seconds.
  function wait() { if (build()) return; if (++tries < 100) setTimeout(wait, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait); else wait();

  window.AEChat = { open: function () { open(btn); }, isOpen: isOpen };
})();
